import { motion } from "framer-motion";
import { CalendarClock, Zap, ArrowRight } from "lucide-react";
import { formatDateTime, formatPoints } from "@/lib/format";

const ScoreCard = ({ score }) => {
  const official = score.mode === "OFICIAL";
  return (
    <div className="glass-card relative overflow-hidden p-8 sm:p-10" data-testid="score-card">
      <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full opacity-20 blur-3xl" style={{ background: "var(--brand)" }} />
      <p className="font-display text-2xl leading-snug text-slate-50 sm:text-3xl" data-testid="score-text">
        Pontuação Rewards:{" "}
        <span className="gold-text whitespace-nowrap">{formatPoints(score.points)} pontos</span>
      </p>
      {official && (
        <p className="mt-3 text-sm text-slate-400" data-testid="score-source">
          Fonte: {score.source} · Consultado em {formatDateTime(score.obtained_at)}
        </p>
      )}
    </div>
  );
};

export const ScoreStep = ({ state, onSchedule, onRedeemNow, busy }) => {
  const online = state.online_service;
  return (
  <motion.div initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-3xl" data-testid="score-step">
    <p className="eyebrow mb-4">Protocolo {state.protocolo} · {state.tipo === "PF" ? "CPF" : "CNPJ"} {state.cnpj_fmt}</p>
    <ScoreCard score={state.score} />
    <h2 className="mt-12 text-base font-medium text-slate-200 md:text-lg">Como deseja seguir com o atendimento?</h2>
    <div className={`mt-5 grid gap-5 ${online ? "" : "md:grid-cols-2"}`}>
      {!online && <button onClick={onSchedule} className="option-card group text-left" data-testid="schedule-redemption-btn">
        <CalendarClock className="h-7 w-7" style={{ color: "var(--brand)" }} />
        <p className="mt-5 font-display text-xl text-slate-50">Agendar resgate</p>
        <p className="mt-2 text-sm text-slate-400">Escolha o melhor horário e nossa equipe entra em contato.</p>
        <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold" style={{ color: "var(--brand)" }}>
          Continuar <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </span>
      </button>}
      {online ? (
        <button onClick={onRedeemNow} disabled={busy} className="option-card group text-left" data-testid="instant-redemption-btn">
          <Zap className="h-7 w-7" style={{ color: "var(--brand)" }} />
          <p className="mt-5 font-display text-xl text-slate-50">Resgatar agora</p>
          <p className="mt-2 text-sm text-slate-400">Um operador está online para dar continuidade ao seu resgate agora.</p>
          <span className="mt-6 inline-flex items-center gap-2 text-sm font-semibold" style={{ color: "var(--brand)" }}>
            Continuar <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </span>
        </button>
      ) : (
        <button disabled className="option-card cursor-not-allowed text-left opacity-50" data-testid="instant-redemption-btn-disabled" aria-disabled="true">
          <Zap className="h-7 w-7 text-slate-500" />
          <p className="mt-5 font-display text-xl text-slate-300">Resgatar agora</p>
          <p className="mt-2 text-sm text-slate-500" data-testid="instant-redemption-soon">Funcionalidade disponível em breve.</p>
        </button>
      )}
    </div>
  </motion.div>
  );
};
